import { MutableRefObject, useEffect } from 'react';

export default function useKeyUpOutside(
  targetKey: string,
  ref: MutableRefObject<HTMLElement | null>,
  handler: () => void,
  isListenerStopped: boolean = false
) {
  useEffect(() => {
    const listener = (evt: KeyboardEvent) => {
      if (!ref?.current || ref.current.contains(evt.target as any)) {
        return;
      }

      if (evt.key === targetKey) {
        handler();
      }
    };

    if (!isListenerStopped) {
      window.addEventListener('keyup', listener);
    } else {
      window.removeEventListener('keyup', listener);
    }

    return () => {
      window.removeEventListener('keyup', listener);
    };
  }, [handler, isListenerStopped, ref, targetKey]);
}
